export const LOT_PLAN_URL = "/assets/lot-plan.webp";

export const LOTS = [
  {
    id: "s1",
    name: "Lot S1",
    tagline: "The largest available lot, ideally positioned along the Lake Pontchartrain levee.",
    description:
      "Lot S1 is the premier homesite in this offering. With 18,213 square feet, it provides significantly more space than the other available properties and offers flexibility for a custom residence, outdoor living areas, landscaping and additional site features. Its size, Platt Street frontage and levee-side setting make Lot S1 a distinctive opportunity within Woodlake Estates.",
    sqft: "18,213",
    acres: "0.418",
    street: "Platt Street frontage",
    feature: "Located along the Lake Pontchartrain levee — largest available lot",
    price: "$599,000",
    status: "Available",
    premier: true,
    pin: { left: "27%", top: "74%" },
  },
  {
    id: "s3a1",
    name: "Lot S3A1",
    tagline: "A uniquely shaped homesite located near the Verde Street cul-de-sac.",
    description:
      "Lot S3A1 offers 9,912 square feet and a distinctive irregular configuration. Its location near the Verde Street cul-de-sac provides a unique option for buyers interested in creating a custom home designed specifically around the property.",
    sqft: "9,912",
    acres: "0.228",
    street: "Verde Street access",
    feature: "Near the Verde Street cul-de-sac — irregular lot configuration",
    price: "$220,000",
    status: "Available",
    pin: { left: "43%", top: "59%" },
  },
  {
    id: "s4a",
    name: "Lot S4A",
    tagline: "A well-proportioned homesite with frontage along Platt Street.",
    description:
      "Lot S4A contains 9,604 square feet and offers a generally practical configuration for custom residential construction. Its Platt Street location provides convenient access within Woodlake Estates.",
    sqft: "9,604",
    acres: "0.220",
    street: "Platt Street frontage",
    feature: "Well-proportioned homesite",
    price: "$175,000",
    status: "Available",
    pin: { left: "56%", top: "60%" },
  },
  {
    id: "s5a",
    name: "Lot S5A",
    tagline: "An efficiently shaped homesite offering an attractive value along Platt Street.",
    description:
      "Lot S5A contains 9,503 square feet and provides a practical setting for a custom residence. Its generally regular layout may accommodate a variety of home designs and outdoor living plans.",
    sqft: "9,503",
    acres: "0.218",
    street: "Platt Street frontage",
    feature: "Practical lot configuration",
    price: "$165,000",
    status: "Available",
    pin: { left: "65%", top: "61%" },
  },
  {
    id: "s6a",
    name: "Lot S6A",
    tagline: "A desirable corner homesite with frontage on Platt Street and Sequoia Street.",
    description:
      "Lot S6A offers a prominent corner location within Woodlake Estates. With frontage on two streets, the property may provide additional flexibility when considering the placement and orientation of a custom home.",
    sqft: "9,501",
    acres: "0.218",
    street: "Platt Street & Sequoia Street frontage",
    feature: "Corner lot",
    price: "$185,000",
    status: "Available",
    pin: { left: "74%", top: "60%" },
  },
  {
    id: "s7a",
    name: "Lot S7A",
    tagline: "A cul-de-sac homesite offering a quieter residential setting on Verde Street.",
    description:
      "Lot S7A is positioned at the Verde Street cul-de-sac and contains 9,500 square feet. Its location may appeal to buyers looking for a homesite with limited through traffic and a more private residential setting.",
    sqft: "9,500",
    acres: "0.218",
    street: "Verde Street cul-de-sac frontage",
    feature: "Limited through traffic",
    price: "$185,000",
    status: "Available",
    pin: { left: "55%", top: "40%" },
  },
  {
    id: "s8a",
    name: "Lot S8A",
    tagline: "A well-positioned homesite with direct frontage along Sequoia Street.",
    description:
      "Lot S8A contains 9,501 square feet and offers a generally efficient configuration for a custom residence. Its Sequoia Street frontage provides convenient access within the neighborhood.",
    sqft: "9,501",
    acres: "0.218",
    street: "Sequoia Street frontage",
    feature: "Practical building configuration",
    price: "$165,000",
    status: "Available",
    pin: { left: "72%", top: "38%" },
  },
  {
    id: "s2a1",
    name: "Lot S2A1",
    tagline: "A large homesite located at the Verde Street cul-de-sac.",
    description: "",
    sqft: "16,689",
    acres: "0.383",
    street: "Verde Street cul-de-sac frontage",
    feature: "Second-largest lot in the collection",
    price: null,
    status: "Sold",
    pin: { left: "27%", top: "48%" },
  },
];

export const FAQ_ITEMS = [
  {
    q: "How many lots are currently available?",
    a: "Seven homesites are currently available. Lot S2A1 has been sold.",
  },
  {
    q: "Can I select my own builder?",
    a: "Contact us for information regarding construction requirements, builder selection and any applicable neighborhood guidelines.",
  },
  {
    q: "Are surveys available?",
    a: "Contact us to request available property information and supporting documents.",
  },
  {
    q: "Can I visit the lots?",
    a: "Yes. Contact us to arrange a convenient time to view the available properties.",
  },
  {
    q: "Are the prices subject to change?",
    a: "Yes. Pricing and availability are subject to change without notice.",
  },
  {
    q: "Are there building restrictions or neighborhood requirements?",
    a: "Buyers should review all applicable subdivision restrictions, servitudes, building requirements and governmental regulations before purchasing or designing a home.",
  },
];

export const FULL_DISCLAIMER =
  "All information, including pricing, availability, lot dimensions, square footage, acreage, street frontage, access, boundaries, servitudes and property characteristics, is believed to be accurate but is not guaranteed. The lot plan and website are provided for general marketing and informational purposes only and are not a substitute for a current survey, title review, inspection, architectural review or professional evaluation. Buyers should independently verify all information and applicable building requirements before purchasing a property. Pricing and availability are subject to change without notice.";

export const PLAN_DISCLAIMER =
  "The lot plan is provided for general informational purposes. Lot dimensions, boundaries, servitudes, access, availability and other property information should be independently verified by the buyer.";
